/**
 * Lightweight instant translator for core utils/services outside templates.
 * Wired once from APP_INITIALIZER to TranslateService.instant.
 * Falls back to the key when not configured (e.g. unit tests).
 */
type TranslateInstantFn = (key: string, params?: Record<string, unknown>) => string;

let translateInstantFn: TranslateInstantFn | null = null;

export function configureTranslateInstant(fn: TranslateInstantFn): void {
  translateInstantFn = fn;
}

export function ti(key: string, params?: Record<string, unknown>): string {
  return translateInstantFn?.(key, params) ?? key;
}
